<form class="flex flex-col gap-10" [formGroup]="formGroup()">
  <p-card header="Adres zamieszkania" class="custom-card">
    <app-form-address
      [formGroup]="formGroup().controls.adres"
    ></app-form-address>
    <div class="mb-10 mt-6">
      <p-checkbox
        [formControl]="formGroup().controls.czyAdresKorespondencyjny"
        [binary]="true"
        [inputId]="'czyAdresKorespondencyjny'"
        styleClass="customCheckbox"
      />
      <label [for]="'czyAdresKorespondencyjny'" class="ml-2"
        >Adres korespondencyjny inny niż adres zamieszkania</label
      >
    </div>
  </p-card>
  @if (formGroup().controls.czyAdresKorespondencyjny.value === true) {
    <p-card header="Adres korespondencyjny" class="custom-card">
      <app-form-address
        [formGroup]="formGroup().controls.adresKorespondencyjny"
      ></app-form-address>
    </p-card>
  }
</form>
